import {
  TabsContent,
  TabsContents
} from "./chunk-35QRZSEV.mjs";
import {
  TabsList,
  TabsTab
} from "./chunk-J5SCUELT.mjs";
import {
  TabsContext
} from "./chunk-KQITCS3U.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/tabs/tabs.tsx
import { forwardRef, useState } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
var Tabs = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, defaultTab, children } = _b, rest = __objRest(_b, ["asChild", "defaultTab", "children"]);
    const [activeTabId, setActiveTabId] = useState(defaultTab);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({ className: clsx("hds-tabs"), ref }, rest), { children: /* @__PURE__ */ jsx(TabsContext.Provider, { value: { activeTabId, toggleActiveTabId: setActiveTabId }, children }) }));
  }
);
Tabs.displayName = "Tabs";
Tabs.List = TabsList;
Tabs.Tab = TabsTab;
Tabs.Contents = TabsContents;
Tabs.Content = TabsContent;

export {
  Tabs
};
//# sourceMappingURL=chunk-KNGG6M2I.mjs.map